import React from 'react';
import { motion } from 'framer-motion';
import { FaUsers, FaDatabase, FaGlobe, FaGlobeAmericas } from 'react-icons/fa';

const StatsSection = () => {
  const stats = [
    {
      icon: <FaUsers className="h-8 w-8 text-blue-600" />,
      title: "Registered Users",
      value: "150+",
      description: "Users who have generated datasets"
    },
    {
      icon: <FaDatabase className="h-8 w-8 text-blue-600" />,
      title: "Data Points Generated",
      value: "110K+",
      description: "Synthetic data points created"
    },
    {
      icon: <FaGlobe className="h-8 w-8 text-blue-600" />,
      title: "Domains Served",
      value: "4+",
      description: "Education, Cybersecurity & more"
    },
    {
      icon: <FaGlobeAmericas className="h-8 w-8 text-blue-600" />,
      title: "Global Website Reach",
      value: "15+",
      description: "Countries visiting our platform"
    }
  ];

  return (
    <div className="py-24 bg-gradient-to-br from-white to-blue-50 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-blue-100 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-indigo-100 rounded-full opacity-10 blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-blue-600 mb-4">
            Our Growth
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tracking our journey from the start
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ 
                duration: 0.6,
                delay: index * 0.1,
                ease: [0.2, 0.65, 0.3, 0.9]
              }}
              className="group relative"
            >
              <div className="flex flex-col items-center text-center">
                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 mb-6 transform group-hover:scale-110 transition-transform duration-500">
                  {stat.icon}
                </div>
                <motion.h3 
                  className="text-4xl font-bold mb-2 text-blue-600"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 + 0.2 }}
                >
                  {stat.value}
                </motion.h3>
                <h4 className="text-lg font-semibold text-blue-600 mb-2">{stat.title}</h4>
                <p className="text-gray-600 text-sm">{stat.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;